import type EnhancedLocation from 'owa-service/lib/contract/EnhancedLocation';
import type PersonaPostalAddress from 'owa-service/lib/contract/PersonaPostalAddress';
import type { BookingPostalAddressInput } from 'owa-graph-schema';

const mapEnhancedLocationToPostalAddress = (
    location: EnhancedLocation | undefined
): BookingPostalAddressInput | undefined => {
    if (!location) {
        return;
    }

    const { DisplayName, PostalAddress = {} } = location;
    const {
        Street = '',
        City,
        State,
        Country,
        PostalCode,
        PostOfficeBox,
        Type,
        LocationSource,
    } = PostalAddress as PersonaPostalAddress;
    const mappedPostalAddress: BookingPostalAddressInput = {
        name: DisplayName,
        street: Street,
        city: City,
        state: State,
        countryOrRegion: Country,
        postalCode: PostalCode,
        postOfficeBox: PostOfficeBox,
        type: Type,
        locationSource: LocationSource,
    };
    return mappedPostalAddress;
};

export default mapEnhancedLocationToPostalAddress;
